import React, { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import QuickActionsHeader from "./QuickActionsHeader/QuickActionsHeader";
import QuickActionsTabs from "./QuickActionsTabs/QuickActionsTabs";
import { formatTitleCase } from "../../../utils/formatHelpers";
import { LoadService } from "../../../services/LoadService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function QuickActions() {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  let [searchParams] = useSearchParams();
  const [load, setLoad] = useState({});
  const [loadStatus, setLoadStatus] = useState(load?.brokerageStatus);
  const [originLocation, setOriginLocation] = useState("");
  const [destinationLocation, setDestinationLocation] = useState("");

  const handleClose = () => {
    window.close();
  };

  useEffect(() => {
    if (load?.stops) {
      const originStop = load.stops[0];
      const destinationStop = load.stops[load.stops.length - 1];

      setOriginLocation(`${formatTitleCase(originStop.cityName)}, ${originStop.state}`);
      setDestinationLocation(`${formatTitleCase(destinationStop.cityName)}, ${destinationStop.state}`);
    }
  }, [load]);

  useEffect(() => {
    const loadId = searchParams.get("loadId");

    if (loadId) {
      LoadService.GetLoad(instance, loadId).then(res => {
        setLoad(res);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }
  }, []);

  return (
    <Box sx={{ margin: "10px" }}>
      <QuickActionsHeader
        load={load}
        originLocation={originLocation}
        destinationLocation={destinationLocation}
        brokerageStatus={loadStatus}
      />
      <QuickActionsTabs
        activeLoad={load}
        handleClose={handleClose}
        setLoadStatus={setLoadStatus}
        setLoad={setLoad}
      />
    </Box>
  );
}

QuickActions.propTypes = {};